import Template from "../../components/Template";
import { useNavigate } from 'react-router-dom';
import { useNavigation } from '../../context/NavigationContext';
import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import * as XLSX from "xlsx";
import AlertDialog from "../../components/AlertDialog";
import { Link } from "react-router-dom";
import usePermission from "../../hooks/usePermission";
import useListFilterState from "../../hooks/useListFilterState";
import { maskCurrency, formatCurrencyFromDb } from "../../utils/masks";
import { formatDateWithoutHour } from "../../utils/date";
import { statusParaFiltro } from "../../utils/statusPedidoCompra";

import useRequisicaoMaisRecente from '../../hooks/useRequisicaoMaisRecente';
const PedidosCompraList = () => {
    const navigate = useNavigate();
    const podeEditar = usePermission("EDITAR_PEDIDO_COMPRA");
    const podeExcluir = usePermission("EXCLUIR_PEDIDO_COMPRA");
    
    const [fornecedores, setFornecedores] = useState([]);
    const [obras, setObras] = useState([]);
    const [compradores, setCompradores] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const { updateMenu } = useNavigation();
    const [pedidos, setPedidos] = useState([]);
    // Sem isto a tabela dizia "Nenhum pedido encontrado" enquanto carregava,
    // e também quando a busca falhava
    const [carregando, setCarregando] = useState(true);
    const [erroCarga, setErroCarga] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const menuRef = useRef(null);
    const menuFiltrarRef = useRef(null);
    const buttonRef = useRef(null);
    const buttonFiltrarRef = useRef(null);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const { filters, setFilters, isSearchActive, setIsSearchActive, pageSize, setPageSize, hasRestoredFilters, clearPersistedState } = useListFilterState('pedidos-compra', {
        numero: "",
        fornecedor: "",
        obra: "",
        comprador: "",
        status: "",
        dataInicio: "",
        dataFim: "",
        dataVencimentoInicio: "",
        dataVencimentoFim: "",
        valorMinimo: "",
        valorMaximo: "",
    });
    const [message, setMessage] = useState("");
    const appliedFiltersRef = useRef({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [fornecedoresRes, obrasRes, usersRes, statusRes] = await Promise.all([
                    api.get("/fornecedores/todos"),
                    api.get("/obras/listar/todas"),
                    api.get("/users"),
                    api.get("/pedidos-compra/status")
                ]);
                setFornecedores(fornecedoresRes.data);
                setObras(obrasRes.data);
                setCompradores(usersRes.data || []);
                
                // A API retorna { status: [...], total: n }
                setStatusList(statusParaFiltro(statusRes.data.status));
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
                // Garantir que statusList seja sempre um array
                setStatusList([]);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (hasRestoredFilters()) {
            applyFilters();
            return;
        }
        fetchPedidos(1, pageSize);
    }, []);

    const handleEditarClick = (pedidoId) => {
        if (!podeEditar) {
            alert("Você não tem permissão para editar pedidos de compra");
            return;
        }
        navigate(`/pedidos-compra/${pedidoId}/editar`);
    };

    // Descarta respostas de filtros que já foram superados por outro mais novo:
    // sem isto, a resposta lenta de um filtro anterior sobrescrevia a tela.
    const requisicaoMaisRecente = useRequisicaoMaisRecente();

    const fetchPedidos = async (page, size) => {
        let idRequisicao = null;
        try {
            const params = new URLSearchParams();
            params.set('page', page.toString());
            params.set('limit', size.toString());

            // Incluir filtros aplicados
            Object.entries(appliedFiltersRef.current).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    params.set(key, value.toString());
                }
            });

            idRequisicao = requisicaoMaisRecente.iniciar();
            setCarregando(true);
            const response = await api.get(`/pedidos-compra?${params.toString()}`);

            // Chegou atrasada e ja foi superada por outro filtro: descarta.
            if (!requisicaoMaisRecente.ehAtual(idRequisicao)) return;
            setErroCarga(false);

            const corpo = response.data || {};
            const pedidosData = corpo.data || corpo.pedidos || corpo.records || corpo;
            const lista = Array.isArray(pedidosData) ? pedidosData : [];
            setPedidos(lista);
            const total = corpo.pagination?.total ?? corpo.total;
            setTotalRecords(Number.isFinite(total) ? total : lista.length);
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
            if (idRequisicao === null || requisicaoMaisRecente.ehAtual(idRequisicao)) {
                setErroCarga(true);
                setPedidos([]);
                setTotalRecords(0);
            }
        } finally {
            if (idRequisicao === null || requisicaoMaisRecente.ehAtual(idRequisicao)) setCarregando(false);
        }
    };

    // Mensagem da tabela quando não há linhas: carregando, erro ou vazio de verdade
    const estadoSemLinhas = () => {
        if (carregando) return <span role="status">Carregando pedidos...</span>;
        if (erroCarga) {
            return (
                <span role="alert">
                    Não foi possível carregar os pedidos.{' '}
                    <button type="button" className="underline text-stone-700 hover:text-stone-900" onClick={() => fetchPedidos(currentPage, pageSize)}>
                        Tentar novamente
                    </button>
                </span>
            );
        }
        return 'Nenhum pedido encontrado';
    };

    const handleNavigateCadastrar = async (e) => {
        e.preventDefault();
        try {
            navigate('/pedidos-compra/novo');
        } catch (err) {
            console.error('Pedidos Compra Error:', err);
            alert(err.response?.data?.msg || 'Erro ao ir para o cadastro');
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchPedidos(page, pageSize);
    };

    const totalPages = Math.ceil(totalRecords / pageSize);
    const startRecord = totalRecords > 0 ? (currentPage - 1) * pageSize + 1 : 0;
    const endRecord = Math.min(currentPage * pageSize, totalRecords);

    const pageWindowSize = 5;
    // Mantem a janela cheia tambem nas ultimas paginas (antes ela encolhia).
    const startPage = Math.max(1, Math.min(currentPage - Math.floor(pageWindowSize / 2), totalPages - pageWindowSize + 1));
    const endPage = Math.min(totalPages, startPage + pageWindowSize - 1);

    const pageNumbers = Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
    );

    const getStatusLabel = (status) => {
        const statusLabels = {
            'RASCUNHO': 'Rascunho',
            'EM_ORCAMENTO': 'Em Orçamento',
            'AGUARDANDO_APROVACAO': 'Aguardando Aprovação',
            'APROVADO': 'Aprovado',
            'REJEITADO': 'Rejeitado',
            'EM_ANDAMENTO': 'Em Andamento',
            'RECEBIDO': 'Recebido',
            'FINALIZADO': 'Finalizado'
        };
        return statusLabels[status] || status;
    };

    const [columns, setColumns] = useState([
        {
            id: "id",
            label: "ID",
            visible: true,
            formatter: (value) => (
                <Link to={`/pedidos-compra/${value}`} className="text-stone-600 hover:underline">
                    {value}
                </Link>
            ),
        },
        {
            id: "numeroOC",
            label: "Número",
            visible: true,
            formatter: (value) => value || "",
        },
        {
            id: "fornecedor",
            label: "Fornecedor",
            visible: true,
            formatter: (value) => value?.nome || value?.nomeFornecedor || "",
        },
        {
            id: "obra",
            label: "Obra",
            visible: true,
            formatter: (value) => value?.nome || value?.nomeProjeto || "N/A",
        },
        {
            id: "dataEmissao",
            label: "Data Emissão",
            visible: true,
            formatter: (value) => value ? formatDateWithoutHour(value) : "",
        },
        {
            id: "valorFinal",
            label: "Valor Total (R$)",
            visible: true,
            formatter: (value) => formatCurrencyFromDb(value),
        },
        {
            id: "status",
            label: "Status",
            visible: true,
            formatter: (value) => {
                // value pode ser um objeto { id, nome, ... } ou uma string
                let statusNome;
                if (typeof value === 'object' && value !== null) {
                    statusNome = value.nome || 'Sem Status';
                } else {
                    statusNome = getStatusLabel(value);
                }

                // Função para obter a cor do status
                const getStatusColor = (status) => {
                    const colors = {
                        'Rascunho': '#9CA3AF',
                        'Em Orçamento': '#F97316',
                        'Aguardando Aprovação': '#F59E0B',
                        'Aprovado': '#10B981',
                        'Rejeitado': '#EF4444',
                        'Em andamento': '#3B82F6',
                        'Recebida': '#8B5CF6',
                        'Concluído': '#6366F1',
                        'Pendente': '#F59E0B',
                        'Cancelada': '#475569',
                        'Sem Status': '#9CA3AF'
                    };
                    return colors[status] || '#9CA3AF';
                };

                return (
                    <span style={{
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "600",
                        backgroundColor: getStatusColor(statusNome),
                        color: "#FFFFFF",
                        display: "inline-block",
                        whiteSpace: "nowrap"
                    }}>
                        {statusNome}
                    </span>
                );
            },
        },
        {
            id: "acoes",
            label: "Ações",
            visible: true,
            formatter: (value, pedido) => {
                // Verificar se o status permite edição (Rascunho ou Em Orçamento)
                const statusNomeAcoes = typeof pedido.status === 'object' ? pedido.status?.nome : pedido.status;
                const isRascunho = statusNomeAcoes === 'Rascunho' || statusNomeAcoes === 'RASCUNHO' || statusNomeAcoes === 'Em Orçamento' || statusNomeAcoes === 'EM_ORCAMENTO';
                
                return (
                    <div className="flex gap-2 justify-center items-center" style={{ minWidth: "100px" }}>
                        <Link to={`/pedidos-compra/${pedido.id}`}>
                            <img 
                                src="/images/icon/search.png" 
                                alt="Visualizar" 
                                title="Visualizar"
                                style={{ 
                                    width: "24px", 
                                    height: "24px",
                                    minWidth: "24px",
                                    minHeight: "24px",
                                    cursor: "pointer"
                                }} 
                            />
                        </Link>
                        {isRascunho && (
                            <>
                                <img 
                                    src="images/icon/edit.png" 
                                    alt="Editar" 
                                    title="Editar"
                                    onClick={() => handleEditarClick(pedido.id)}
                                    style={{ 
                                        width: "20px", 
                                        height: "20px",
                                        minWidth: "20px",
                                        minHeight: "20px",
                                        cursor: "pointer"
                                    }} 
                                />
                                <img 
                                    src="images/icon/trash.png" 
                                    alt="Excluir" 
                                    title="Excluir"
                                    onClick={() => handleDelete(pedido.id)}
                                    style={{ 
                                        width: "20px", 
                                        height: "20px",
                                        minWidth: "20px",
                                        minHeight: "20px",
                                        cursor: "pointer"
                                    }}
                                />
                            </>
                        )}
                    </div>
                );
            },
        },
    ]);

    const [menuOpen, setMenuOpen] = useState(false);
    const [menuFiltrarOpen, setMenuFiltrarOpen] = useState(false);

    const toggleColumnVisibility = (id) => {
        setColumns((prevColumns) =>
            prevColumns.map((col) =>
                col.id === id ? { ...col, visible: !col.visible } : col
            )
        );
    };

    const handleClickOutside = (event) => {
        if (
            buttonRef.current &&
            !buttonRef.current.contains(event.target) &&
            buttonFiltrarRef.current &&
            !buttonFiltrarRef.current.contains(event.target)
        ) {
            setMenuOpen(null);
        }
    };

    useEffect(() => {
        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    const handleMenuClick = (event) => {
        event.stopPropagation();
    };

    const applyFilters = () => {
        const query = {};

        if (filters.numero) query.numeroOC = filters.numero;
        if (filters.fornecedor) query.fornecedorId = filters.fornecedor;
        if (filters.obra) query.obraId = filters.obra;
        if (filters.comprador) query.compradorId = filters.comprador;
        if (filters.status) query.statusId = filters.status;
        if (filters.dataInicio) query.dataInicio = filters.dataInicio;
        if (filters.dataFim) query.dataFim = filters.dataFim;
        if (filters.dataVencimentoInicio) query.dataVencimentoInicio = filters.dataVencimentoInicio;
        if (filters.dataVencimentoFim) query.dataVencimentoFim = filters.dataVencimentoFim;
        if (filters.valorMinimo) query.valorMinimo = parseFloat(filters.valorMinimo.replace(/[^\d,]/g, '').replace(',', '.'));
        if (filters.valorMaximo) query.valorMaximo = parseFloat(filters.valorMaximo.replace(/[^\d,]/g, '').replace(',', '.'));

        appliedFiltersRef.current = query;
        setCurrentPage(1);
        fetchPedidos(1, pageSize);
        setMenuOpen(null);
    };

    const clearFilters = () => {
        clearPersistedState();
        setFilters({
            numero: "",
            fornecedor: "",
            obra: "",
            comprador: "",
            status: "",
            dataInicio: "",
            dataFim: "",
            dataVencimentoInicio: "",
            dataVencimentoFim: "",
            valorMinimo: "",
            valorMaximo: "",
        });
        appliedFiltersRef.current = {};
        setCurrentPage(1);
        fetchPedidos(1, pageSize);
        setMenuOpen(null);
    };

    const handleSearch = () => {
        const query = {};
        if (filters.numero) query.numeroOC = filters.numero;
        appliedFiltersRef.current = query;
        setCurrentPage(1);
        fetchPedidos(1, pageSize);
    };

    const exportToExcel = () => {
        if (pedidos.length === 0) {
            setMessage('Não há dados para exportar!');
            setShowSuccessDialog(true);
            return;
        }

        const dataToExport = pedidos.map((pedido) => {
            const row = {};
            columns.forEach((col) => {
                if (col.visible && col.id !== 'acoes') {
                    let value = pedido[col.id];
                    
                    // Para campos numéricos (valor), não usar o formatter
                    if (col.id === 'valorFinal') {
                        // Manter como número para permitir autosoma no Excel
                        row[col.label] = typeof value === 'number' ? value : parseFloat(value) || 0;
                    } else if (col.id === 'status') {
                        // Para status, pegar o nome se for objeto
                        row[col.label] = typeof value === 'object' && value !== null ? value.nome : value;
                    } else if (col.id === 'fornecedor') {
                        // Para fornecedor, pegar o nome
                        row[col.label] = value?.nome || value?.nomeFornecedor || '';
                    } else if (col.id === 'obra') {
                        // Para obra, pegar o nome
                        row[col.label] = value?.nome || value?.nomeProjeto || 'N/A';
                    } else if (col.id === 'dataEmissao') {
                        // Para data, formatar
                        row[col.label] = value ? formatDateWithoutHour(value) : '';
                    } else {
                        // Para outros campos, usar o valor direto ou formatter se retornar string
                        row[col.label] = col.formatter && typeof col.formatter(value, pedido) === 'string' 
                            ? col.formatter(value, pedido) 
                            : value;
                    }
                }
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        
        // Configurar formato de número para a coluna de valor
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        const valorColIndex = columns.findIndex(col => col.id === 'valorFinal' && col.visible);
        
        if (valorColIndex !== -1) {
            // Aplicar formato de moeda brasileira na coluna de valor
            for (let row = range.s.r + 1; row <= range.e.r; row++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: valorColIndex });
                if (worksheet[cellAddress] && typeof worksheet[cellAddress].v === 'number') {
                    worksheet[cellAddress].z = '#,##0.00';
                    worksheet[cellAddress].t = 'n';
                }
            }
        }
        
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Pedidos de Compra");
        XLSX.writeFile(workbook, "pedidos_compra.xlsx");
    };

    const handleDelete = async (id) => {
        if (!podeExcluir) {
            alert("Você não tem permissão para excluir pedidos de compra");
            return;
        }
        
        if (window.confirm("Deseja realmente excluir este pedido?")) {
            try {
                await api.delete(`/pedidos-compra/${id}`);
                setMessage("Pedido excluído com sucesso!");
                setShowSuccessDialog(true);
                fetchPedidos(currentPage, pageSize);
            } catch (error) {
                console.error("Erro ao excluir pedido:", error);
                alert("Erro ao excluir pedido");
            }
        }
    };

    // Helper para obter status formatado de um pedido
    const getStatusInfo = (pedido) => {
        const statusValue = pedido.status;
        let statusNome;
        if (typeof statusValue === 'object' && statusValue !== null) {
            statusNome = statusValue.nome || 'Sem Status';
        } else {
            statusNome = getStatusLabel(statusValue);
        }
        const getStatusColor = (status) => {
            const colors = {
                'Rascunho': '#9CA3AF',
                'Em Orçamento': '#F97316',
                'Aguardando Aprovação': '#F59E0B',
                'Aprovado': '#10B981',
                'Rejeitado': '#EF4444',
                'Em andamento': '#3B82F6',
                'Recebida': '#8B5CF6',
                'Concluído': '#6366F1',
                'Pendente': '#F59E0B',
                'Cancelada': '#475569',
                'Sem Status': '#9CA3AF'
            };
            return colors[status] || '#9CA3AF';
        };
        return { nome: statusNome, color: getStatusColor(statusNome) };
    };

    // Verifica se pedido permite edição (Rascunho ou Em Orçamento)
    const isRascunho = (pedido) => {
        const statusNome = typeof pedido.status === 'object' ? pedido.status?.nome : pedido.status;
        return statusNome === 'Rascunho' || statusNome === 'RASCUNHO' || statusNome === 'Em Orçamento' || statusNome === 'EM_ORCAMENTO';
    };

    return (
        <Template>
            <div className="h-auto w-full p-3 sm:p-4 md:p-8 flex flex-col gap-4 md:gap-6">
                {/* Título + Botão Cadastrar */}
                <div className="flex flex-wrap justify-between items-center gap-3">
                    <div className="text-stone-800 text-lg sm:text-xl md:text-2xl font-medium font-['Inter']">Pedidos de Compra</div>
                    {usePermission('CRIAR_PEDIDO_COMPRA') && (
                        <button 
                            type='button' 
                            className="px-3 py-2 sm:px-4 bg-stone-600 text-white rounded-md flex items-center gap-2" 
                            onClick={handleNavigateCadastrar}
                        >
                            <img className="w-4 h-4" src="images/icon/plus-circle.png" alt="Cadastrar" />
                            <div className="text-white text-sm font-medium font-['Inter'] leading-normal">Cadastrar</div>
                        </button>
                    )}
                </div>

                {/* Toolbar: Ver X Resultados | Colunas | Filtrar | Pesquisar | Exportar */}
                <div className="flex flex-col gap-3">
                    {/* Linha 1: Resultados por página + Ações */}
                    <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                        <div className="flex items-center gap-2">
                            <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-tight">Ver</div>
                            <select
                                className="w-16 sm:w-20 h-8 pl-2 pr-1 py-1 bg-white rounded-md border border-slate-300 text-sm text-slate-700"
                                value={pageSize}
                                onChange={(e) => {
                                    const newSize = parseInt(e.target.value, 10);
                                    setPageSize(newSize);
                                    setCurrentPage(1);
                                    fetchPedidos(1, newSize);
                                }}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={200}>200</option>
                                <option value={300}>300</option>
                            </select>
                            <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-tight hidden sm:block">Resultados</div>
                        </div>

                        <div className="flex items-center gap-2 sm:gap-3 ml-auto flex-wrap">
                            {/* Colunas (desktop only) */}
                            <div ref={buttonRef} className="relative items-center gap-1 hidden md:flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "colunas" ? null : "colunas")}>
                                <div className="items-center gap-2 flex">
                                    <img className="w-6 h-6 relative" src="images/icon/columns.png" alt="Colunas" />
                                    <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Colunas</div>
                                </div>
                                <img className="w-6 h-4 px-1" src="images/icon/chevron-down.png" alt="Expandir" />
                                {menuOpen === "colunas" && (
                                    <div className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg"
                                        style={{ zIndex: 9999 }}
                                        onClick={handleMenuClick}
                                    >
                                        <div className="p-4 flex flex-col gap-3">
                                            {columns.filter(col => col.id !== 'acoes').map((col) => (
                                                <div key={col.id} className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        id={col.id}
                                                        checked={col.visible}
                                                        onChange={() => toggleColumnVisibility(col.id)}
                                                    />
                                                    <label htmlFor={col.id} className="text-sm text-gray-700">
                                                        {col.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Filtrar */}
                            <div ref={buttonFiltrarRef} className="relative items-center gap-1 flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "filtro" ? null : "filtro")}>
                                <div className="items-center gap-1 sm:gap-2 flex">
                                    <img className="w-7 h-7 sm:w-8 sm:h-8" src="images/icon/filter.png" alt="Filtrar" />
                                    <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal hidden sm:block">Filtrar</div>
                                </div>
                                <img className="w-5 h-3 sm:w-6 sm:h-4 px-0.5" src="images/icon/chevron-down.png" alt="Expandir" />
                                {menuOpen === "filtro" && (
                                    <div
                                        className="fixed inset-0 sm:absolute sm:inset-auto sm:top-full sm:right-0 sm:left-auto sm:mt-2 sm:w-[350px] bg-white sm:rounded-md shadow-lg p-4 border-0 sm:border sm:border-gray-300 overflow-y-auto"
                                        style={{ zIndex: 9999 }}
                                        onClick={handleMenuClick}
                                    >
                                        <div className="flex flex-col gap-4 max-w-lg mx-auto sm:max-w-none">
                                            <div className="flex justify-between items-center">
                                                <div className="text-stone-800 text-xl font-medium">Filtrar</div>
                                                <button className="sm:hidden text-stone-500 text-2xl px-2" onClick={() => setMenuOpen(null)}>&times;</button>
                                            </div>

                                            <div className="flex flex-col gap-1.5">
                                                <div className="text-slate-700 text-sm font-medium leading-tight">Número</div>
                                                <input
                                                    type="text"
                                                    name="numero"
                                                    className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-base text-slate-700"
                                                    placeholder="Número do Pedido"
                                                    value={filters.numero}
                                                    onChange={(e) => setFilters({ ...filters, numero: e.target.value })}
                                                />
                                            </div>

                                            <div className="flex flex-col gap-1.5">
                                                <div className="text-slate-700 text-sm font-medium leading-tight">Fornecedor</div>
                                                <select
                                                    name="fornecedor"
                                                    className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                                    value={filters.fornecedor}
                                                    onChange={(e) => setFilters({ ...filters, fornecedor: e.target.value })}
                                                >
                                                    <option value="">Selecionar</option>
                                                    {fornecedores.map((f) => (
                                                        <option key={f.id} value={f.id}>{f.nome || f.nomeFornecedor}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="flex flex-col gap-1.5">
                                                <div className="text-slate-700 text-sm font-medium leading-tight">Obra</div>
                                                <select
                                                    name="obra"
                                                    className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                                    value={filters.obra}
                                                    onChange={(e) => setFilters({ ...filters, obra: e.target.value })}
                                                >
                                                    <option value="">Selecionar</option>
                                                    {obras.map((o) => (
                                                        <option key={o.id} value={o.id}>{o.nome || o.nomeProjeto}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="flex flex-col gap-1.5">
                                                <div className="text-slate-700 text-sm font-medium leading-tight">Comprador</div>
                                                <select
                                                    name="comprador"
                                                    className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                                    value={filters.comprador}
                                                    onChange={(e) => setFilters({ ...filters, comprador: e.target.value })}
                                                >
                                                    <option value="">Selecionar</option>
                                                    {compradores.map((c) => (
                                                        <option key={c.id} value={c.id}>{c.nome}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="flex flex-col gap-1.5">
                                                <div className="text-slate-700 text-sm font-medium leading-tight">Status</div>
                                                <select
                                                    name="status"
                                                    className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                                    value={filters.status}
                                                    onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                                                >
                                                    <option value="">Selecionar</option>
                                                    {statusList.map((status) => (
                                                        <option key={status.id} value={status.id}>{status.nome}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="grid grid-cols-2 gap-3">
                                                <div className="flex flex-col gap-1.5">
                                                    <div className="text-slate-700 text-sm font-medium leading-tight">Data Início</div>
                                                    <input type="date" className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-base text-slate-700"
                                                        value={filters.dataInicio}
                                                        onChange={(e) => setFilters({ ...filters, dataInicio: e.target.value })}
                                                    />
                                                </div>
                                                <div className="flex flex-col gap-1.5">
                                                    <div className="text-slate-700 text-sm font-medium leading-tight">Data Fim</div>
                                                    <input type="date" className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-base text-slate-700"
                                                        value={filters.dataFim}
                                                        onChange={(e) => setFilters({ ...filters, dataFim: e.target.value })}
                                                    />
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-3">
                                                <div className="flex flex-col gap-1.5">
                                                    <div className="text-slate-700 text-sm font-medium leading-tight">Vencimento De</div>
                                                    <input type="date" className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-base text-slate-700"
                                                        value={filters.dataVencimentoInicio}
                                                        onChange={(e) => setFilters({ ...filters, dataVencimentoInicio: e.target.value })}
                                                    />
                                                </div>
                                                <div className="flex flex-col gap-1.5">
                                                    <div className="text-slate-700 text-sm font-medium leading-tight">Vencimento Até</div>
                                                    <input type="date" className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-base text-slate-700"
                                                        value={filters.dataVencimentoFim}
                                                        onChange={(e) => setFilters({ ...filters, dataVencimentoFim: e.target.value })}
                                                    />
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-3">
                                                <div className="flex flex-col gap-1.5">
                                                    <div className="text-slate-700 text-sm font-medium leading-tight">Valor Mín (R$)</div>
                                                    <input type="text" placeholder="0,00"
                                                        className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-base text-slate-700"
                                                        value={filters.valorMinimo}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/\D/g, '');
                                                            const formattedValue = (parseInt(value) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                                            setFilters({ ...filters, valorMinimo: value ? formattedValue : '' });
                                                        }}
                                                    />
                                                </div>
                                                <div className="flex flex-col gap-1.5">
                                                    <div className="text-slate-700 text-sm font-medium leading-tight">Valor Máx (R$)</div>
                                                    <input type="text" placeholder="0,00"
                                                        className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-base text-slate-700"
                                                        value={filters.valorMaximo}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/\D/g, '');
                                                            const formattedValue = (parseInt(value) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                                            setFilters({ ...filters, valorMaximo: value ? formattedValue : '' });
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="flex items-center justify-between gap-3 mt-2">
                                                <button className="px-4 py-2 w-full bg-white rounded-md border border-stone-500 justify-center items-center gap-2 flex" onClick={clearFilters}>
                                                    <img className="w-4 h-4 relative" src="images/icon/eraser.png" alt="Limpar" />
                                                    <div className="text-stone-500 text-sm font-medium font-['Inter'] leading-normal">Limpar</div>
                                                </button>
                                                <button className="px-4 py-2 w-full bg-stone-600 rounded-md justify-center items-center gap-2 flex" onClick={applyFilters}>
                                                    <img className="w-4 h-4 relative" src="images/icon/filter-white.png" alt="Filtrar" />
                                                    <div className="text-white text-sm font-medium font-['Inter'] leading-normal">Filtrar</div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Pesquisar */}
                            <div className="flex items-center gap-2">
                                {!isSearchActive ? (
                                    <div className="items-center gap-1 sm:gap-2 flex cursor-pointer" onClick={() => setIsSearchActive(true)}>
                                        <img className="w-8 h-8 sm:w-10 sm:h-10 relative" src="images/icon/search.png" alt="Pesquisar" />
                                        <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal hidden sm:block">Pesquisar</div>
                                    </div>
                                ) : (
                                    <div className="flex items-center gap-2">
                                        <div className="h-9 px-2 sm:px-3 py-2 bg-white rounded-md border border-slate-300 flex items-center">
                                            <input
                                                type="text"
                                                placeholder="Número"
                                                className="w-20 sm:w-full text-slate-400 text-sm sm:text-base font-normal font-['Inter'] leading-tight focus:outline-none"
                                                value={filters.numero}
                                                onChange={(e) => setFilters({ ...filters, numero: e.target.value })}
                                                onKeyPress={(e) => { if (e.key === 'Enter') handleSearch(); }}
                                            />
                                            <img className="w-5 h-5 cursor-pointer ml-1" src="images/icon/close.png" alt="Fechar"
                                                onClick={() => {
                                                    setIsSearchActive(false);
                                                    setFilters({ ...filters, numero: "" });
                                                    appliedFiltersRef.current = {};
                                                    setCurrentPage(1);
                                                    fetchPedidos(1, pageSize);
                                                }}
                                            />
                                        </div>
                                        <button className="px-3 py-2 bg-stone-600 rounded-md flex items-center gap-1" onClick={handleSearch}>
                                            <img className="w-4 h-4" src="images/icon/search-white.png" alt="Pesquisar" />
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* Exportar */}
                            {usePermission('EXPORTAR_PEDIDO_COMPRA') && (
                                <button 
                                    type='button' 
                                    className="flex px-3 py-2 bg-white/40 rounded-md border border-stone-600 items-center gap-1 sm:gap-2 cursor-pointer" 
                                    onClick={exportToExcel}
                                >
                                    <img className="w-4 h-4" src="images/icon/upload.png" alt="Exportar" />
                                    <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal hidden sm:block">Exportar</div>
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* === TABELA (Desktop: md+) === */}
                <div className="hidden md:block overflow-x-auto">
                    <table className={`min-w-full bg-white border-collapse border border-gray-200 ${carregando && pedidos.length > 0 ? 'opacity-60' : ''}`} aria-busy={carregando}>
                        <thead className="bg-stone-200">
                            <tr>
                                {columns
                                    .filter((col) => col.visible)
                                    .map((col) => (
                                        <th key={col.id} className="px-4 py-2 border border-slate-200 text-slate-800 text-base font-bold">
                                            {col.label}
                                        </th>
                                    ))}
                            </tr>
                        </thead>
                        <tbody>
                            {pedidos.length === 0 ? (
                                <tr>
                                    <td colSpan={columns.filter(col => col.visible).length} className="px-4 py-8 text-center text-slate-500 text-base">
                                        {estadoSemLinhas()}
                                    </td>
                                </tr>
                            ) : (
                                pedidos.map((pedido) => (
                                    <tr key={pedido.id}>
                                        {columns
                                            .filter((col) => col.visible)
                                            .map((col) => (
                                                <td key={`${pedido.id}-${col.id}`} className="px-4 py-2 border border-slate-200 text-slate-700 text-base">
                                                    {col.formatter(pedido[col.id], pedido)}
                                                </td>
                                            ))}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* === CARDS (Mobile: < md) === */}
                <div className="md:hidden flex flex-col gap-3">
                    {pedidos.length === 0 ? (
                        <div className="py-8 text-center text-slate-500 text-base bg-white rounded-lg border border-gray-200">
                            {estadoSemLinhas()}
                        </div>
                    ) : (
                        pedidos.map((pedido) => {
                            const statusInfo = getStatusInfo(pedido);
                            const rascunho = isRascunho(pedido);
                            return (
                                <div key={pedido.id} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                                    {/* Card Header */}
                                    <div className="flex items-center justify-between px-4 py-3 bg-stone-50 border-b border-gray-200">
                                        <div className="flex items-center gap-2">
                                            <Link to={`/pedidos-compra/${pedido.id}`} className="text-stone-700 font-semibold text-sm hover:underline">
                                                {pedido.numeroOC || `#${pedido.id}`}
                                            </Link>
                                            <span style={{
                                                padding: "2px 8px",
                                                borderRadius: "10px",
                                                fontSize: "11px",
                                                fontWeight: "600",
                                                backgroundColor: statusInfo.color,
                                                color: "#FFFFFF",
                                                whiteSpace: "nowrap"
                                            }}>
                                                {statusInfo.nome}
                                            </span>
                                        </div>
                                        <div className="flex gap-2 items-center">
                                            <Link to={`/pedidos-compra/${pedido.id}`}>
                                                <img src="/images/icon/search.png" alt="Ver" className="w-5 h-5 cursor-pointer" />
                                            </Link>
                                            {rascunho && (
                                                <>
                                                    <img src="images/icon/edit.png" alt="Editar" className="w-5 h-5 cursor-pointer"
                                                        onClick={() => handleEditarClick(pedido.id)} />
                                                    <img src="images/icon/trash.png" alt="Excluir" className="w-5 h-5 cursor-pointer"
                                                        onClick={() => handleDelete(pedido.id)} />
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    {/* Card Body */}
                                    <div className="px-4 py-3 flex flex-col gap-2 text-sm">
                                        <div className="flex justify-between">
                                            <span className="text-slate-500">Fornecedor</span>
                                            <span className="text-slate-700 font-medium text-right max-w-[60%] truncate">
                                                {pedido.fornecedor?.nome || pedido.fornecedor?.nomeFornecedor || '-'}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-slate-500">Obra</span>
                                            <span className="text-slate-700 font-medium text-right max-w-[60%] truncate">
                                                {pedido.obra?.nome || pedido.obra?.nomeProjeto || 'N/A'}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-slate-500">Emissão</span>
                                            <span className="text-slate-700 font-medium">
                                                {pedido.dataEmissao ? formatDateWithoutHour(pedido.dataEmissao) : '-'}
                                            </span>
                                        </div>
                                        <div className="flex justify-between border-t border-gray-100 pt-2 mt-1">
                                            <span className="text-slate-500 font-medium">Valor Total</span>
                                            <span className="text-stone-800 font-bold">
                                                {formatCurrencyFromDb(pedido.valorFinal)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>

                {/* === PAGINAÇÃO === */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="text-slate-500 text-sm sm:text-base font-normal font-['Inter'] leading-relaxed text-center sm:text-left">
                        {(carregando || erroCarga) && totalRecords === 0 ? '' : `Mostrando de ${startRecord} até ${endRecord} de ${totalRecords} registros.`}
                    </div>
                    <div className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap">
                        <button
                            className={`w-9 h-9 sm:w-10 sm:h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex ${
                                currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-300 cursor-pointer"
                            }`}
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            <img className="w-5 h-5 sm:w-6 sm:h-6 relative" src="images/icon/keyboard-arrow-left.png" alt="Anterior" />
                        </button>

                        {pageNumbers.map((page) => (
                            <button
                                key={page}
                                className={`w-9 h-9 sm:w-10 sm:h-10 rounded justify-center items-center flex text-sm sm:text-base font-semibold font-['Inter'] ${
                                    page === currentPage
                                        ? "bg-stone-600 text-white"
                                        : "bg-gray-200 text-gray-600"
                                }`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}

                        <button 
                            className={`w-9 h-9 sm:w-10 sm:h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex ${
                                currentPage >= totalPages || totalPages === 0 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
                            }`}
                            disabled={currentPage >= totalPages || totalPages === 0}
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            <img className="w-5 h-5 sm:w-6 sm:h-6 relative" src="images/icon/keyboard-arrow-right.png" alt="Próximo" />
                        </button>
                    </div>
                </div>

                <AlertDialog
                    isVisible={showSuccessDialog}
                    message={message}
                    onClose={() => setShowSuccessDialog(false)}
                />
            </div>
        </Template>
    );
};

export default PedidosCompraList;
